<template>
    <div class="widget-item widget-chart" :class="this.chartData.type">
        <a v-if="!editDisabled && !chartData.required && $parent.createMode" @click.prevent="$parent.removeWidget(this.chartData.id);" class="remove-widget"><i class="fa fa-times"></i></a>
        <div class="title">
            {{this.chartData.title}}
        </div>
        <div>
            <canvas :id="this.chartId"></canvas>
        </div>
    </div>
</template>

<script type="text/javascript">
    var base_url = window.location.protocol + "//" + window.location.host

    import Vue from 'vue';
    import VueEvents from 'vue-events'
    import axios from 'axios'
    import moment from 'moment';
    import 'chartjs-plugin-colorschemes/src/plugins/plugin.colorschemes';

    Vue.use(VueEvents)

    export default {
        name: 'widget-chart',
        props: [
            'chartData',
            'chartId',
            'editDisabled',
        ],
        data() {
            return {
                loadedChartData: this.chartData,
                id: this.chartId,
                colorScheme: [
                    '#02A7CD',
                    '#3CAB9F',
                    '#E8A341',
                    '#AB5755',
                    '#25628F',
                    '#09E3D0',
                    '#CC165C',
                    '#0E6B80',
                    '#CC6102',
                    '#805E0E',
                    '#0CCC85',
                    '#A616CC',
                    '#D26937',
                    '#013F4D',
                    '#83CC0C',
                ]
            }
        },
        mounted() {
            if (typeof this.chartData.data.colorOverrides != 'undefined' && this.chartData.data.colorOverrides.scheme.length != 0) {
                this.colorOverride(this.chartData.data.colorOverrides.scheme, this.chartData.data.colorOverrides.fullOverride);
            }

            setTimeout(function(){
                this.createChart(this.chartId, this.chartData);
            }.bind(this), 100);
        },
        methods: {
            createChart(chartId, chartData) {
                var ctx = document.getElementById(chartId);
                var myChart = new Chart(ctx, {
                    type: chartData.type,
                    data: chartData.data,
                    options: {
                        maintainAspectRatio: false,
                        plugins: {
                            colorschemes: {
                                scheme: this.colorScheme,
                            }
                        }
                    },
                });
            },
            colorOverride(schemeColors, fullOverride) {
                if (fullOverride && schemeColors.length > 0) {
                    this.colorScheme = schemeColors;
                    return;
                }
                this.colorScheme =  schemeColors.concat(this.colorScheme);
            }
        },
    };
</script>

<style scoped="" lang="scss">
    .widget-chart{
        padding: 20px 20px 5px 20px !important;
        .title{
            font-size: 18px;
            font-weight: 400;
            color: #7D7D7D;
            text-align: center;
            margin-bottom: 15px;
            margin-right: 0;
            padding: 0px 5px;
        }
    }
</style>
